import React, { useEffect, useState } from 'react';
import { translate } from "react-translate";
import { useForm, Controller } from 'react-hook-form';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
  Row,
  Col
} from 'reactstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from "react-redux";
import useCountriesByLang from 'hooks/useCountriesByLang';

const PracticeOrdersDeliveryForm = (props) => {

    const dispatch = useDispatch();
    const { practices } = useSelector(state => state.practicesReducer.practices);
    const [practiceInfo, setPracticeInfo] = useState({});

    //Local dropdown control
    const [country, _setCountry] = useState({});

    const setCountry = (e) => {
        _setCountry(e);
        setCountryPick(e);
    }

    const { 
        t, 
        register, 
        errors, 
        setEdited,
        orderEdit,
        setCountryPick,
        practicePick
    } = props;

    const orderAddressExists = Object.keys(orderEdit).length && orderEdit.shipping_address_practice;

    const countryOptions = useCountriesByLang('react-select');

    useEffect(() => {
        if (!Object.keys(country).length) {
            setCountry(orderAddressExists ? orderEdit.shipping_address_practice.address.country : Object.keys(practiceInfo).length ? countryOptions.find(c => c.label === practiceInfo.country) : "");
        }
    }, []);

    //Set practiceInfo each time the practice pickup changes
    useEffect(() => {
        if (practices && practices.length) {
            const p = practices.find(p => p._id === practicePick);

            if (p && (!Object.keys(practiceInfo).length || practiceInfo._id !== practicePick)) {
                setPracticeInfo(p);

                //Find country option by label (translation dependent)
                const opt = countryOptions.find(c => c.label === p.country);
                if (opt) {
                    setCountry(opt);
                }
            }
        }
    }, [practicePick]);

    return (
        <>
            <Row>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.country && 'has-danger'} `}>
                        <label>{t("country")}</label>
                        <Select
                            name="country"
                            id="country"
                            value={country}
                            className="react-select info"
                            classNamePrefix="react-select"
                            placeholder={t("country")}
                            options={countryOptions}
                            onChange={e => {
                                setCountry(e);
                                setCountryPick(e);
                                setEdited(true);
                            }}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.street && 'has-danger'} `}>
                        <label>{t("street-address")}</label>
                        <Input
                            name="street"
                            placeholder={t("street-address")}
                            defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.address.street : Object.keys(practiceInfo).length ? practiceInfo.street : ""}
                            onChange={e => {
                                setEdited(true);
                            }}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.streetNumber && 'has-danger'} `}>
                        <label>{t("street-number")}</label>
                        <Input
                            name="streetNumber"
                            placeholder={t("street-number")}
                            defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.address.streetNumber : ""}
                            onChange={e => {
                                setEdited(true);
                            }}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.apartment && 'has-danger'} `}>
                        <label>{t("apartment-suite-other")}</label>
                        <Input
                            name="apartment"
                            placeholder={t("apartment-suite-other")}
                            defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.address.apartment : Object.keys(practiceInfo).length ? practiceInfo.appartment : ""}
                            onChange={e => {
                                setEdited(true);
                            }}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.phone && 'has-danger'
                            } `}>
                    <label>{t("phone-number")}</label>
                    <Input
                        name="phone"
                        id="phone"
                        placeholder={t("phone-number")}
                        type="phone"
                        onChange={e => {
                            setEdited(true);
                        }}
                        defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.phone : Object.keys(practiceInfo).length ? practiceInfo.telephone : ""}
                        innerRef={register}
                    />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.postalCode && 'has-danger'} `}>
                        <label>{t("postal-code")}</label>
                        <Input
                            name="postalCode"
                            placeholder={t("postal-code")}
                            defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.address.postalCode : Object.keys(practiceInfo).length ? practiceInfo.postal_code : ""}
                            onChange={e => {
                                setEdited(true);
                            }}
                            innerRef={register}
                            
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup
                        className={`has-label ${errors.city && 'has-danger'} `}>
                        <label>{t("city")}</label>
                        <Input
                            name="city"
                            placeholder={t("city")}
                            defaultValue={orderAddressExists ? orderEdit.shipping_address_practice.address.city : Object.keys(practiceInfo).length ? practiceInfo.city : ""}
                            onChange={e => {
                                setEdited(true);
                            }}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}

export default translate("practice-orders")(PracticeOrdersDeliveryForm);
